const appLauncher = {
  allApps: "כל האפליקציות",
  entities: "ישויות",
  history: "היסטוריה",
  records: "רשומות",
  noRecords: "אין רשומות",
  noHistory: "אין היסטוריה",
  openApp: "פתח {appName}",
  justNow: "עכשיו",
  minutesAgo: "לפני {minutes} דק׳",
  hoursAgo: "לפני {hours} שע׳",
  daysAgo: "לפני {days} ימים",
} as const;

export default appLauncher;